import axios from "axios";

const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://woodelicious.ch/api";

const Api = axios.create({
  baseURL: apiBaseUrl,
});

// ------------------------------------------------
// REQUEST-INTERCEPTOR
// ------------------------------------------------
Api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    const authEndpoints = [
      "/auth/login",
      "/auth/register",
      "/auth/request-password-reset",
      "/auth/reset-password",
    ];

    const isAuthRequest = authEndpoints.some((p) =>
      config.url?.startsWith(p)
    );

    if (token && !isAuthRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ------------------------------------------------
// RESPONSE-INTERCEPTOR
// ------------------------------------------------
Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) return Promise.reject(error);

    if (error.response.status === 401) {
      localStorage.clear();

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default Api;
